module.exports = __webpack_public_path__ + "static/media/gray-large-angle-pattern.e93b3afe.jpg";